var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceFee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 16C22.3284 16 23 16.6716 23 17.5C23 18.3284 22.3284 19 21.5 19L21.6533 19.0078C22.4097 19.0846 23 19.7233 23 20.5C23 21.3284 22.3284 22 21.5 22H17C16.1716 22 15.5 21.3284 15.5 20.5C15.5 19.7233 16.0903 19.0846 16.8467 19.0078L17 19C16.1716 19 15.5 18.3284 15.5 17.5C15.5 16.6716 16.1716 16 17 16H21.5ZM20 10C20.8284 10 21.5 10.6716 21.5 11.5V14.875H17C15.5503 14.875 14.375 16.0503 14.375 17.5C14.375 18.0577 14.5491 18.5748 14.8457 19C14.5491 19.4252 14.375 19.9423 14.375 20.5H9.5C8.67157 20.5 8 19.8284 8 19V11.5C8 10.6716 8.67157 10 9.5 10H20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceFee);
export default __webpack_public_path__ + "static/media/service_fee.ec50fc34ac5a48a6a2a93149c7404e5c.svg";
export { ForwardRef as ReactComponent };